import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const attemptsRef = useRef(0);

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let done = false;
    const poll = async () => {
      if (done) return;
      attemptsRef.current += 1;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); done = true; return; }
        if (r.data.status === "expired") { setStatus("expired"); done = true; return; }
      } catch {}
      if (attemptsRef.current >= 8) { setStatus("timeout"); return; }
      setTimeout(poll, 2000);
    };
    poll();
    return () => { done = true; };
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <main className="pt-40 max-w-xl mx-auto px-6 text-center" data-testid="payment-success-page">
        {status === "pending" && (<><Loader2 className="mx-auto animate-spin text-seafoam" /> <div className="mt-6 text-slate-600">Confirming your payment…</div></>)}
        {status === "paid" && (<>
          <CheckCircle2 size={48} className="mx-auto text-emerald-600" strokeWidth={1.5} />
          <h1 className="mt-6 text-4xl font-light tracking-tight">Reservation confirmed.</h1>
          <p className="mt-4 text-slate-600">Your itinerary will appear in your dashboard. Our team will reach out within 24 hours.</p>
          <Link to="/dashboard" data-testid="go-dashboard" className="mt-8 inline-flex btn-pill bg-slate-900 text-white hover:bg-slate-800">Open dashboard</Link>
        </>)}
        {status === "expired" && (<>
          <XCircle size={48} className="mx-auto text-rose-600" strokeWidth={1.5} />
          <h1 className="mt-6 text-4xl font-light tracking-tight">Session expired.</h1>
          <Link to="/tours" className="mt-8 inline-flex btn-pill bg-slate-900 text-white">Back to tours</Link>
        </>)}
        {status === "timeout" && (
          <div className="text-slate-600">Still processing. Please check your dashboard in a moment.</div>
        )}
        {status === "error" && <div className="text-slate-600">Missing session id.</div>}
      </main>
    </div>
  );
}
